import * as React from 'react';
import { useGetProductsBySkus } from '@grandvisionhq/fun-search';
import { ProductBlockRow } from '@grandvisionhq/lib-visuals';
import { useFeatureToggles } from '@grandvisionhq/state';
import { isDefined } from '@grandvisionhq/utils';
import { ProductListingRowBlock } from './components/ProductListingRowBlock/ProductListingRowBlock.js';

const ProductListingRow = ({ skus  })=>{
    const { isBloomreachVariantEanDisplayEnabled  } = useFeatureToggles();
    const { listingProducts , loading  } = useGetProductsBySkus({
        skus
    });
    const products = React.useMemo(()=>{
        if (!listingProducts || !listingProducts.length) {
            return [];
        }
        if (!isBloomreachVariantEanDisplayEnabled) {
            return listingProducts.map((product)=>({
                    product,
                    selectedVariant: undefined
                })
            );
        }
        const productMap = new Map();
        listingProducts.forEach((product)=>{
            productMap.set(product.masterVariant.sku, product);
            product.variants.forEach((variant)=>{
                productMap.set(variant.sku, product);
            });
        });
        return skus.map((sku)=>({
                product: productMap.get(sku),
                selectedVariant: sku
            })
        ).filter(({ product  })=>isDefined(product)
        );
    }, [
        listingProducts,
        isBloomreachVariantEanDisplayEnabled,
        skus
    ]);
    var _selectedVariant;
    return /*#__PURE__*/ React.createElement(ProductBlockRow, {
        isLoading: loading
    }, products.map((item)=>/*#__PURE__*/ React.createElement(ProductListingRowBlock, {
            key: (_selectedVariant = item.selectedVariant) !== null && _selectedVariant !== void 0 ? _selectedVariant : item.product.slug,
            listingProduct: item.product,
            selectedVariant: item.selectedVariant
        })
    ));
};

export { ProductListingRow };
//# sourceMappingURL=ProductListingRow.js.map
